import { Frequency } from '../../../../../apis/graphql/types';

export const REPORT_ROUTES = {
  report: '/reports',
  updateReport: (reportId: string): string => `/${reportId}/edit`,
  create: '/create',
  edit: '/edit',
  info: '/info',
};

export const initialValues = {
  name: '',
  startDate: undefined,
  endDate: undefined,
  lineItemsIds: [],
  campaign: '',
  weekday: ['SUNDAY'],
  targeting: ['GEO', 'AUDIENCE', 'PLATFORM', 'GENRE'],
  emailNow: true,
  frequency: Frequency.Daily,
  userIds: [],
};
